"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.assignFromAccountRaw = exports.assignToAccountRaw = exports.applyReconciliation = void 0;
var bignumber_js_1 = require("bignumber.js");
var isEqual_1 = __importDefault(require("lodash/isEqual"));
function toResourcesRaw(r) {
    var rewards = r.rewards, nbAssets = r.nbAssets;
    return {
        rewards: rewards.toString(),
        nbAssets: nbAssets
    };
}
function fromResourcesRaw(r) {
    var rewards = r.rewards, nbAssets = r.nbAssets;
    return {
        rewards: new bignumber_js_1.BigNumber(rewards),
        nbAssets: nbAssets
    };
}
function applyReconciliation(account, updatedRaw, next) {
    var changed = false;
    var algorandAcc = account;
    var algorandUpdatedRaw = updatedRaw;
    if (!(0, isEqual_1["default"])(algorandAcc.algorandResources, algorandUpdatedRaw.algorandResources)) {
        next.algorandResources = fromResourcesRaw(algorandUpdatedRaw.algorandResources);
        changed = true;
    }
    return changed;
}
exports.applyReconciliation = applyReconciliation;
function assignToAccountRaw(account, accountRaw) {
    var algorandAccount = account;
    var algorandAccountRaw = accountRaw;
    if (algorandAccount.algorandResources) {
        algorandAccountRaw.algorandResources = toResourcesRaw(algorandAccount.algorandResources);
    }
}
exports.assignToAccountRaw = assignToAccountRaw;
function assignFromAccountRaw(accountRaw, account) {
    var algorandResourcesRaw = accountRaw
        .algorandResources;
    var algorandAccount = account;
    if (algorandResourcesRaw) {
        algorandAccount.algorandResources = fromResourcesRaw(algorandResourcesRaw);
    }
}
exports.assignFromAccountRaw = assignFromAccountRaw;
//# sourceMappingURL=serialization.js.map